import ChargeHelper from 'features/Charge/chargeHelper';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';

ChargePointListFilterView.propTypes = {
    isInDropdown: PropTypes.bool,
    chargePointListFilter: PropTypes.object,
    selectedChargeStation: PropTypes.object,
    setSelectedChargeStation: PropTypes.func,
    updateFilter: PropTypes.func,
    setFilterDropdown: PropTypes.func,
    filterDropdown: PropTypes.object,
};

function ChargePointListFilterView({
    isInDropdown = true,
    chargePointListFilter,
    selectedChargeStation,
    setSelectedChargeStation,
    updateFilter,
    setFilterDropdown,
    filterDropdown,
}) {
    // MARK: ---- PROPERTIES ----

    const dropdownChargeStationEl = useMemo(() => {
        return (
            <CustomDropdown2
                id="stationIdEl"
                name="stationIdEl"
                toggleElement={
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                        type="button"
                    >
                        {selectedChargeStation?.name ?? 'Tất cả'}
                    </button>
                }
                selectedValue={selectedChargeStation}
                subTitleType="address"
                dropdownMenuItems={[{ name: 'Trạm sạc', role: 'STATION' }]}
                getSubItems={async (item) => {
                    return ChargeHelper.API.requestGetChargeStationList({
                        page: item?.page || 0,
                        limit: 10,
                        q: item?.q || '',
                    }).then((data) => {
                        return {
                            values: data.chargeStations?.map((station) => ({
                                id: station?.stationId,
                                name: station?.name,
                                item: station,
                                address: ChargeHelper.Utils.getChargeStationFullAddress(station),
                            })),
                            total: data.total,
                        };
                    });
                }}
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                dropdownMenuClassName="overflow-auto w-100"
                onChange={(value) => {
                    setSelectedChargeStation(value);
                    if (isInDropdown) {
                        setFilterDropdown({ ...filterDropdown, stationId: value?.id });
                    } else {
                        updateFilter('stationId', value?.id);
                    }
                }}
                isDropdownForm={true}
                titleSearchable={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
                ignoreConfirmClick={true}
                defaultValue={{
                    name: 'Trạm sạc',
                    role: 'STATION',
                }}
                footerEl={
                    <div
                        className="p-4 position-sticky sticky-bottom bg-white"
                        style={{
                            borderTop: `1px solid ${AppColors.gray[300]}`,
                        }}
                    >
                        {UIHelper.buildNegativeButton('Bỏ chọn', () => {
                            if (isInDropdown) {
                                setFilterDropdown({ ...filterDropdown, stationId: '' });
                            } else {
                                updateFilter('stationId', '');
                            }
                            setSelectedChargeStation(null);
                        })}
                    </div>
                }
            />
        )
    }, [selectedChargeStation])

    // MARK: ---- METHODS ----
    const chargingSpeedOptions = [
        { value: '', name: 'Tất cả' },
        { value: 'NORMAL', name: 'Sạc thường: ≤ 11 kW' },
        { value: 'FAST', name: 'Sạc nhanh: 20 kW → 60 kW' },
        { value: 'SUPERFAST', name: 'Sạc siêu nhanh: ≥ 120kW' },
    ]
    return (
        <div>
            <div className={`${'col-12 p-0'}`}>
                <KTFormSearch
                    name="search-bar"
                    placeholder="Theo mã trụ sạc, mã OCPP, số điện thoại..."
                    value={filterDropdown?.q}
                    onSubmit={(text) => {
                        const updateFilterDropdown = { ...filterDropdown, q: text };
                        setFilterDropdown(updateFilterDropdown);
                    }}
                />
            </div>
            <div className={`${isInDropdown ? 'row' : 'w-100'} d-flex  flex-row  flex-wrap`}>
                {/* loc theo tram sac */}
                {!!chargePointListFilter && (
                    <div className={`${isInDropdown ? 'col-6 pr-2' : 'flex-grow-1 pr-4'} pt-1`}>
                        {UIHelper.buildFormLabel('Trạm sạc')}
                        {dropdownChargeStationEl}
                    </div>
                )}
                {/* loc theo trang thai */}
                <KTDropdownFilter
                    label='Trạng thái'
                    filterKey="status"
                    options={[
                        { name: 'Tất cả', value: '' },
                        ...ChargeHelper.Data.chargePointStatusOptions,
                    ]}
                    selectedValue={isInDropdown ? filterDropdown?.status : filter?.status}
                    isInDropdown={isInDropdown}
                    additionalClassName={`${isInDropdown ? 'pl-2 pt-2' : 'pr-0 pr-0 pr-xl-4'}`}
                    handleChange={(value) => {
                        if (isInDropdown) {
                            setFilterDropdown({ ...filterDropdown, status: value });
                        } else {
                            updateFilter('status', value);
                        }
                    }}
                />
                {/* loc theo loai tru sac */}
                <KTDropdownFilter
                    label='Loại trụ sạc'
                    filterKey="type"
                    options={[
                        { name: 'Tất cả', value: '' },
                        ...ChargeHelper.Data.chargePointTypeOptions,
                    ]}
                    selectedValue={isInDropdown ? filterDropdown?.type : filter?.type}
                    isInDropdown={isInDropdown}
                    additionalClassName={`${isInDropdown ? 'pr-2 pt-2' : 'pl-0 pr-0 pr-xl-4'}`}
                    handleChange={(value) => {
                        if (isInDropdown) {
                            setFilterDropdown({ ...filterDropdown, type: value });
                        } else {
                            updateFilter('type', value);
                        }
                    }}
                />

                {isInDropdown && (
                    <>
                        {/* cong suat */}
                        <KTDropdownFilter
                            label='Công suất'
                            filterKey="chargingSpeed"
                            options={chargingSpeedOptions}
                            selectedValue={isInDropdown ? filterDropdown?.chargingSpeed : filter?.chargingSpeed}
                            isInDropdown={isInDropdown}
                            additionalClassName={`${isInDropdown ? 'pl-2 pt-2' : 'pl-0 pr-0 pr-xl-4'}`}
                            handleChange={(value) => {
                                if (isInDropdown) {
                                    setFilterDropdown({ ...filterDropdown, chargingSpeed: value });
                                } else {
                                    updateFilter('chargingSpeed', value);
                                }
                            }}
                        />
                        {/* loc theo loai phuong tien */}
                        <KTDropdownFilter
                            label='Loại phương tiện'
                            filterKey="vehicleType"
                            options={[
                                { name: 'Tất cả', value: '' },
                                ...ChargeHelper.Data.vehicleTypeOptions,
                            ]}
                            selectedValue={isInDropdown ? filterDropdown?.vehicleType : filter?.vehicleType}
                            isInDropdown={isInDropdown}
                            additionalClassName={`${isInDropdown ? 'pr-2 pt-2' : 'pl-0 pr-0 pr-xl-4'}`}
                            handleChange={(value) => {
                                if (isInDropdown) {
                                    setFilterDropdown({ ...filterDropdown, vehicleType: value });
                                } else {
                                    updateFilter('vehicleType', value);
                                }
                            }}
                        />
                    </>
                )}
            </div>
            <div className="col-12 mb-4 px-4 mt-2"
                style={{
                    borderBottom: `1px dashed ${AppColors.gray[300]}`
                }}
            />
            <div className='d-flex gap-2 align-items-center'>
                <span style={UIHelper.buildFontStyle('700', '13px', AppColors.gray[800])}>
                    Xem trụ sạc test
                </span>
                {UIHelper.buildToggleSwitch(
                    filterDropdown.isTestChargePoint,
                    () => {
                        setFilterDropdown({ ...filterDropdown, isTestChargePoint: Number(!filterDropdown.isTestChargePoint) });
                    }
                )}
            </div>
        </div>
    );
}

export default ChargePointListFilterView;
